import React, { useState, useCallback, useEffect, useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@reducers/index';
import { gameProviderTypes } from '@configs/layout';
import { Countries2DigitCode, PlayStore_Category_List, AppStore_Category_List, AppleTypes } from '@models/commonModel';
import { IReqTopChartsParams } from '@models/ranking/rankingModle';
import { fetchTopChartsData, fetchNewAppsData, fetchMoverData, fetchLoserData } from '@reducers/ranking/rankingThunk';
import ReactFlagsSelect from 'react-flags-select';
import { useLocation } from 'react-router-dom';
import { setLocaleValue, getLocaleValueForFlag } from '@utils/common/language';

// TODO: params state 따로 관리해서 useEffect [] 에 넣고 바뀔때마다 fetchthunk요청하기!
const SelectBox = () => {
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();

  // button state (현재 버튼임을 확인해주는건 2개이다.)(select 는 params로 대체)
  const [buttonType, setButtonType] = useState(gameProviderTypes.GooglePlayStore);
  const [selectedCountry, setSelectedCountry] = useState(getLocaleValueForFlag());

  const countriesArr = Countries2DigitCode.map((item) => item.code);

  // request params
  const [params, setParams] = useState<IReqTopChartsParams>({
    type: gameProviderTypes.GooglePlayStore, //buttonType state
    category: PlayStore_Category_List[0].value, //select2 value
    num: 10,
    appleType: AppleTypes[0].value, //select3 value
    country: selectedCountry, //selectedCountry state
  });

  // useEffect for reqGridData with params
  useEffect(() => {
    if (params) {
      //TODO: url 경로에 따라 요청하는 fetch가 달라야 한다.. category를 제외한 나머지 공유처리
      switch (location.pathname.split('/')[2]) {
        case 'topCharts':
          dispatch(fetchTopChartsData(params));
          break;
        case 'climbers':
          dispatch(fetchMoverData(params));
          break;
        case 'loser':
          dispatch(fetchLoserData(params));
          break;
        case 'newApps':
          dispatch(fetchNewAppsData(params));
          break;
        default:
          break;
      }
    }
  }, [params]);

  // onClickButtonHandler
  const onClickButtonHandler = useCallback(
    (value: string) => {
      if (value === gameProviderTypes.AppleAppStore) {
        setParams((prev) => ({
          ...prev,
          type: value,
          category: AppStore_Category_List[0].value,
          appleType: AppleTypes[0].value,
        }));
      } else {
        setParams((prev) => ({
          ...prev,
          category: PlayStore_Category_List[0].value,
          type: value,
        }));
      }
      setButtonType(value);
    },
    [gameProviderTypes, AppStore_Category_List, AppleTypes, PlayStore_Category_List]
  );

  // onSelectHandler
  const onChangeSelectHandler = useCallback(
    (event) => {
      const { name, value } = event.target;
      switch (name) {
        case 'category':
          if (buttonType === gameProviderTypes.AppleAppStore) {
            setParams((prev) => ({
              ...prev,
              category: parseInt(value),
            }));
          } else {
            setParams((prev) => ({
              ...prev,
              category: value,
            }));
          }
          break;
        case 'appletype':
          setParams((prev) => ({
            ...prev,
            appleType: value,
          }));
          break;
        case 'countrycode':
          setParams((prev) => ({
            ...prev,
            country: value,
          }));
          break;
        default:
          break;
      }
    },
    [buttonType, gameProviderTypes]
  );

  // onSelectCountryHandler
  const onSelectCountryHandler = useCallback(
    (code) => {
      onChangeSelectHandler({ target: { name: 'countrycode', value: code } });
      setSelectedCountry(code);
    },
    [onChangeSelectHandler]
  );

  return (
    <div className="top-charts-wrap">
      <div className="top-charts-box">
        <div className="top-charts-tit">Top Charts</div>
        {/* 카테고리 select 파트 */}
        <label className="select">
          <select name="category" onChange={onChangeSelectHandler}>
            {buttonType === gameProviderTypes.GooglePlayStore
              ? PlayStore_Category_List.map((item, index) => (
                  <option key={item.value} value={item.value}>
                    {item.text}
                  </option>
                ))
              : AppStore_Category_List.map((item, index) => (
                  <option key={item.value} value={item.value}>
                    {item.text}
                  </option>
                ))}
          </select>
        </label>
        {/* 국가 select 파트 */}
        <label className="top-chart-flag">
          <ReactFlagsSelect
            selected={selectedCountry}
            onSelect={onSelectCountryHandler}
            countries={countriesArr}
            searchable={true}
          />
        </label>
      </div>
      <div className="top-charts-market">
        <button
          type="button"
          className={`btn-ico android ${buttonType === gameProviderTypes.GooglePlayStore ? 'active' : ''}`}
          onClick={() => onClickButtonHandler(gameProviderTypes.GooglePlayStore)}
        >
          <span>Google Store</span>
        </button>
        <button
          type="button"
          className={`btn-ico app ${buttonType === gameProviderTypes.AppleAppStore ? 'active' : ''}`}
          onClick={() => onClickButtonHandler(gameProviderTypes.AppleAppStore)}
        >
          <span>App Store</span>
        </button>
        {/* {buttonType === gameProviderTypes.AppleAppStore && (
          <label className="select">
            <select name="appletype" onChange={onChangeSelectHandler}>
              {AppleTypes.map((item, index) => (
                <option key={index} value={item.value}>
                  {item.text}
                </option>
              ))}
            </select>
          </label>
        )} */}
      </div>
    </div>
  );
};

export default SelectBox;
